import createStateReducer from "../../helpers/createStateReducer";
import states from "../../states/schoolAndLoginModal";
import deltas from "../../actions/deltas";

const {SET_SCHOOL_AND_LOGIN_MODAL_STATE} = deltas.actionTypes;

export default createStateReducer(states, states.CLOSED, SET_SCHOOL_AND_LOGIN_MODAL_STATE);
